import React from "react";
import PageTemplate from "../components/PageTemplate";
import GtQurbani from "../Legends/GtQurbani.jpg";
import MinnesotaJunoon from "../Legends/MinnesotaJunoon.jpeg";
import NuRangila from "../Legends/NuRangila.jpg";
import PurdueKahaani from "../Legends/PurdueKahaani.jpeg";
import UconnSurya from "../Legends/UconnSurya.jpg";
import UcrAag from "../Legends/UcrAag.JPG";
import VanderbiltLakshya from "../Legends/VanderbiltLakshya.jpg";
import WisconsinSurma from "../Legends/WisconsinSurma.JPG";
import ColumbiaRaas from "../RAS/ColumbiaRaas.jpg";
import GwRaas from "../RAS/GwRaas.jpg";
import NeuNakhraas from "../RAS/NeuNakhraas.jpeg";
import SbuRaaswalas from "../RAS/SbuRaaswalas.jpg";
import TexasRaas from "../RAS/TexasRaas.jpeg";
import UconnThunderaas from "../RAS/UconnThunderaas.jpg";
import UvaHooraas from "../RAS/UvaHooraas.png";
import VtDhamaal from "../RAS/VtDhamaal.jpg";

export default function Teams() {
  const legendsTeams = [
    { name: "GT Qurbani", image: GtQurbani },
    { name: "Minnesota Junoon", image: MinnesotaJunoon },
    { name: "NU Rangila", image: NuRangila },
    { name: "Purdue Kahaani", image: PurdueKahaani },
    { name: "UConn Surya", image: UconnSurya },
    { name: "UCR Aag", image: UcrAag },
    { name: "Vanderbilt Lakshya", image: VanderbiltLakshya },
    { name: "Wisconsin Surma", image: WisconsinSurma },
  ];

  const raasAllStarsTeams = [
    { name: "Columbia Raas", image: ColumbiaRaas },
    { name: "GW Raas", image: GwRaas },
    { name: "NEU Nakhraas", image: NeuNakhraas },
    { name: "SBU Raaswalas", image: SbuRaaswalas },
    { name: "Texas Raas", image: TexasRaas },
    { name: "UConn Thunderaas", image: UconnThunderaas },
    { name: "UVA Hooraas", image: UvaHooraas },
    { name: "VT Dhamaal", image: VtDhamaal },
  ];

  return (
    <PageTemplate>
      {/* Hero Section */}
      <div className="bg-gradient-to-br from-pink-100 via-coral-100 to-cream-100 py-8 sm:py-12 lg:py-16 px-4 sm:px-6 relative overflow-hidden">
        <div className="max-w-6xl mx-auto text-center relative z-10">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-text font-bold text-coral mb-4 sm:mb-6 animate-fade-in">
            Participating Teams
          </h1>
          <div className="w-16 sm:w-20 lg:w-24 h-1 bg-coral mx-auto rounded-full"></div>
        </div>
      </div>

      {/* Teams Section */}
      <div className="py-12 sm:py-16 lg:py-20 px-4 sm:px-6 bg-cream-50">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 sm:mb-12">
            <h2 className="text-5xl sm:text-6xl md:text-7xl font-text font-bold text-coral mb-4">
              Legends
            </h2>
            <div className="w-16 sm:w-20 lg:w-24 h-1 bg-coral mx-auto rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 mb-12 sm:mb-16">
            {legendsTeams.map((team) => (
              <div key={team.name} className="text-center">
                <div className="w-full aspect-square overflow-hidden rounded-2xl shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300">
                  <img
                    src={team.image}
                    alt={team.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <p className="mt-4 text-base sm:text-lg font-text font-semibold text-teal-700">
                  {team.name}
                </p>
              </div>
            ))}
          </div>

          <div className="text-center mb-10 sm:mb-12">
            <h2 className="text-4xl sm:text-5xl md:text-6xl font-text font-bold text-coral mb-4">
              Raas All Stars
            </h2>
            <div className="w-16 sm:w-20 lg:w-24 h-1 bg-coral mx-auto rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10">
            {raasAllStarsTeams.map((team) => (
              <div key={team.name} className="text-center">
                <div className="w-full aspect-square overflow-hidden rounded-2xl shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300">
                  <img
                    src={team.image}
                    alt={team.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <p className="mt-4 text-base sm:text-lg font-text font-semibold text-teal-700">
                  {team.name}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

    </PageTemplate>
  );
} 